// Phase 2 - Karnataka SOTTO Fee Structure (Change #22)

// Payment Types
export const PAYMENT_TYPES = {
  ARF: 1, // Annual Registration Fee (Hospital)
  PATIENT_REG: 2, // Patient Registration Fee
  TRANSFER: 3, // Transfer Fee
  TPF: 4, // Transplant Processing Fee
};

// Fee amounts in INR
export const FEE_AMOUNTS = {
  // Annual Registration Fee - Rs.20,000/year per hospital
  ARF: 20000,
  // Patient Registration Fee
  PATIENT_REG_KIDNEY: 3000, // Rs.3,000 for kidney
  PATIENT_REG_OTHER: 5000, // Rs.5,000 for other organs
  // Transfer Fee - Rs.5,000 (non-kidney)
  TRANSFER: 5000,
  // Transplant Processing Fee
  TPF_KIDNEY: 25000, // Rs.25,000 for kidney
  TPF_OTHER: 50000, // Rs.50,000 for other organs (outside in-house)
};

// Kidney organ ID for fee determination
export const KIDNEY_ORGAN_ID = "1";

// Fee type display names
export const FEE_TYPE_NAMES = [
  { name: "Annual Registration Fee (ARF)", value: PAYMENT_TYPES.ARF },
  { name: "Patient Registration Fee", value: PAYMENT_TYPES.PATIENT_REG },
  { name: "Transfer Fee", value: PAYMENT_TYPES.TRANSFER },
  { name: "Transplant Processing Fee (TPF)", value: PAYMENT_TYPES.TPF },
];

/**
 * Get patient registration fee based on organ type
 * @param {string} organId - organ ID
 * @returns {number} fee amount
 */
export function getPatientRegFee(organId) {
  return organId === KIDNEY_ORGAN_ID
    ? FEE_AMOUNTS.PATIENT_REG_KIDNEY
    : FEE_AMOUNTS.PATIENT_REG_OTHER;
}

/**
 * Get transplant processing fee based on organ type
 * @param {string} organId - organ ID
 * @returns {number} fee amount
 */
export function getTPFFee(organId) {
  return organId === KIDNEY_ORGAN_ID
    ? FEE_AMOUNTS.TPF_KIDNEY
    : FEE_AMOUNTS.TPF_OTHER;
}
